"use client";

import Link from "next/link";
import { useCallback, useState } from "react";
import styles from "./searchFeedback.module.scss";

export type SearchFeedbackProps = {
  query: string;
};

const SearchFeedback: React.FC<SearchFeedbackProps> = ({ query }) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleYesClick = useCallback(() => {
    setIsVisible(false);
  }, [setIsVisible]);

  if (!isVisible) return null;

  return (
    <div className={styles.customCard}>
      <p className={styles.heading}>Let&apos;s Help You Find What You Need</p>
      <p className={styles.bodyText}>Did you find what you were looking for?</p>
      <div className={styles.buttonGroup}>
        <button className={styles.feedbackButton} onClick={handleYesClick} type="button">
          Yes
        </button>
        <Link
          className={styles.feedbackButton}
          href={`https://docs.google.com/forms/d/e/1FAIpQLSf7xkOzctkM7EbYehmgzLUYVPbVgjnzNpfNS2BHJZehx7oYTQ/viewform?entry.1523222692=${query}`}
          target="_blank"
        >
          No
        </Link>
      </div>
      <p className={styles.bodyText}>
        If you need help or have a question, please{" "}
        <a href={`${process.env.NEXT_PUBLIC_BASE_URL}/contact-us`}>contact Customer Service.</a>
      </p>
    </div>
  );
};

export default SearchFeedback;
